module.exports = __webpack_public_path__ + "static/bar-with-labels-646284dbf1b316c4afbead851ac8ce8e.png";